import { useForm } from 'react-hook-form';
import {
  Checkbox,
  FormProvider,
  SelectTag,
  Table,
  TextField,
} from '../../../../../components';
import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, Box,  TextField as MuiTextField, } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import CloseIcon from '@mui/icons-material/Close';
import { dateFormatter } from '../../../../../utils';
import axios from 'axios';


const RESULT_ENTRY_HEADER = [
  {
    header: 'Uhid',
    accessor: 'uhid'
  },
  {
    header: 'Ipd No.',
    accessor: (row) => row?.ipd_no || 'N/A'
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row.patientName}`}
        </span>
      );
    }
  },
  {
    header: 'Report Id',
    accessor: (row) => row?.report_id,
  },
  {
    header: 'Status',
    accessor: (row) => row?.status,
    sx: { textTransform: 'uppercase' }
  },
  {
    header: 'Entry Date & Time',
    accessor: (row) => dateFormatter(row.createdAt)
  }
];

const BILL_TABLE_HEADER1 = [
  {
    header: 'Date',
    accessor: 'date'
  },
  {
    header: 'Patient Name',
    accessor: 'patient_name'
  },
  {
    header: 'Uhid',
    accessor: 'uhid'
  },
  {
    header: 'Ipd No.',
    accessor: (row) => row?.ipd_no || 'N/A'
  },
  {
    header: 'Age',
    accessor: 'age'
  },
  {
    header: 'Mobile No',
    accessor: 'mobile_no'
  }
];

const Bill_TABLE_HEADER3 = [
  {
    header: 'Test Name',
    accessor: (row) => row?.test_names || row?.test_name
  },
  {
    header: 'Test Item Name',
    accessor: (row) => row?.test_item_names || row?.test_item_names
  },
  {
    header: 'Result',
    accessor: (row) => row?.test_item_names?.[0]?.Result || row?.tests?.test_item_names?.[0]?.Result
  },
  {
    header: 'Unit',
    accessor: (row) => row?.unit_name || row?.tests?.test_item_names?.[0]?.unit_name
  },
  {
    header: 'Range From',
    accessor: (row) => `${row?.refrence_range_value?.general_from || row?.general_from || 0}`
  },
  {
    header: 'Range To',
    accessor: (row) => `${row?.refrence_range_value?.general_to || row?.general_to || 0}`
  }
];

const initialPatientDataObj = {
  data: [],
  loading: false
};

const initialTestDataObj = {
  data: [],
  loading: false
};

const initialResultEntry = {
  data: [],
  loading: false
};

export const ResultEntry = () => {
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [patientDataObj, setPatientDataObj] = useState(initialPatientDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [testDropdown, setTestDropdown] = useState([]);
  const [subgroupDropdown, setSubgroupDropdown] = useState([]);
  const [investigationDetails, setInvestigationDetails] = useState([]);
  const [testDetailList, setTestDetailList] = useState(initialTestDataObj);
  const [testSampleFilter, setTestSampleFilter] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [patientList, setPatientList] = useState([]);
  const [openResultEntryListDialog, setOpenResultEntryDialog] = useState(false);
  const [resultEntryList, setResultEntryList] = useState(initialResultEntry);
  const [testItemList, setTestItemList] = useState([]);
  const user = JSON.parse(localStorage.getItem('user'));
  const [input,setInput] = useState('');
  const [responseData, setResponseData] = useState([]);
  const [labAuthorityDoctor,setLabAuthorityDoctor] = useState([])
  const [isUserListLoaded, setIsUserListLoaded] = useState(false);
  const [users,setUsers] = useState([])

  useEffect(() => {
    setInputValues((prevValues) => {
      const updatedValues = { ...prevValues };
      investigationDetails.forEach((item) => {
        if (!updatedValues[item._id]) {
          updatedValues[item._id] = {
            ...item,
            result: prevValues[item._id]?.result || ''
          };
        }
      });
      return updatedValues;
    });
  }, [investigationDetails]);

  const handleInputChange = (id, header, value) => {
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [id]: {
        ...prevInputValues[id],
        [header]: value,
      },
    }));
  };
  
  // Helper function to evaluate the dynamic formula
  const evaluateFormula = (formula) => {
    try {
      // Using Function to evaluate the formula safely
      return new Function(`return ${formula}`)();
    } catch (error) {
      console.error('Error in formula evaluation:', error);
      return 0; // Fallback in case of error
    }
  };

  const getTestDropdown = useCallback(async () => {
    const data = await dropdownFetch('lis-test');
    setTestDropdown(data);
  }, []);

  const getSubgorupDropdown = useCallback(async () => {
    const data = await dropdownFetch('test-sub-group');
    setSubgroupDropdown(data);
  }, []);

  const getUserList = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/user`);
      const filteredUsers = response.data.filter((data) => {
        const [firstName, lastName] = user.name.split(' ');
        return data.first_name === firstName && data.last_name === lastName;
      });
      setUsers(filteredUsers[0]?._id);
      setIsUserListLoaded(true);
    } catch (error) {
      console.error('Error fetching user list:', error);
      setIsUserListLoaded(true);
    }
  };

  const handleDoctorDropdown = async () => {
    if (!isUserListLoaded) return;
    setLabAuthorityDoctor({ loading: true, data: [], signoff: {}, amend: {} });
    try {
      const query = { name: users };
      const response = await request('/lab-user-authority-master-list', {
        method: 'GET',
        query: query
      });
      if (response.success) {
        const doctorsData = response.data.flatMap((item) =>
          item.selectedDoctors.map((doctor) => ({
            ...doctor,
            signoff: item.signoff,
            amend: item.amend,   
          }))
        );
        const signoff = response.data[0]?.signoff; 
        const amend = response.data[0]?.amend; 
        setLabAuthorityDoctor({
          loading: false,
          data: doctorsData,
          signoff: signoff,
          amend: amend
        });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setLabAuthorityDoctor({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setLabAuthorityDoctor({ loading: false, data: [] });
    }
  };
  
  useEffect(() => {
    getUserList();
  }, []);

  useEffect(() => {
    if (isUserListLoaded) {
      handleDoctorDropdown();
    }
  }, [isUserListLoaded]);

  useEffect(() => {
    getTestDropdown();
    getSubgorupDropdown();
  }, [getTestDropdown, getSubgorupDropdown,]);

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      date: getCurrentDateTime('date')
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  const handleRowDelete = (rowId) => {
    setDetailList((prev) => prev.filter((data) => data.id !== rowId));
  };

  const fetchData = async () => {
    try {
      const response = await request('/lis-sample-collection-list', { method: 'GET' });
      if (response.success) {
        const fromDate = methods.getValues('from_date');
        const toDate = methods.getValues('to_date');
        const filteredData = filterData(response.data, fromDate, toDate).filter((patient) => {
          return patient.service_items.some((serviceItem) => serviceItem.result === false);
        });

        setPatientDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setPatientDataObj({ loading: false });
      }
    } catch (error) {
      toast('Error in fetching data', { variant: 'error' });
      setPatientDataObj({ loading: false });
    }
  };

  const fetchTestData = async () => {
    try {
      const response = await request('/lis-test-list', { method: 'GET' });
      if (response.success) {
        setTestDetailList({ loading: false, data: response.data });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setTestDetailList({ loading: false, data: [] });
      }
    } catch (error) {
      toast('Error in fetching data', { variant: 'error' });
      setTestDetailList({ loading: false, data: [] });
    }
  };

  const filterData = (data, fromDate, toDate) => {
    let filteredData = [...data];
    if (fromDate && toDate) {
      const from = new Date(fromDate).setHours(0, 0, 0, 0);
      const to = new Date(toDate).setHours(23, 59, 59, 999);
      filteredData = filteredData.filter((item) => {
        const createdAt = new Date(item.date).getTime();
        return createdAt >= from && createdAt <= to;
      });
    }
    return filteredData;
  };

  useEffect(() => {
    fetchData();
  }, [testSampleFilter, methods.watch('from_date'), methods.watch('to_date')]);

  useEffect(() => {
    fetchTestData();
  }, []);

  const handleRowClick = (record) => {
    setOpenQueryDialog(true);
    setSelectedRecord(record);
    setPatientList(record);
    const filteredData = testDetailList.data.filter((item) => {


      const matches = record.service_items.some(
        (serviceItem) => serviceItem.service === item._id && serviceItem.result === false
      );
     
      return matches;
    });
    if (filteredData.length === 0) {

    } else {
      const transformedData = [];
      let serialCounter = 1;
      filteredData.forEach((test) => {
        if (Array.isArray(test.test_item_name)) {
          test.test_item_name.forEach((item) => {
            // Find matching test item in testItemList
            const matchedItem = testItemList.data.find((testItem) => testItem._id === item.test_item_name);
            if (matchedItem) {
              transformedData.push({
                ...matchedItem,
                res_formula: item.res_formula,
                test_names: test.test_name,
                serial: serialCounter++,
                test_item_name: item.test_item_name,
                test_name: test._id,
                test_item_names: item.name
              });
            } else {
              console.log(`No matching test item found for ID: ${item.test_item_name}`);
            }
          });
        } else {
          console.log(`test.test_item_name is not an array for test: ${test.test_name}`);
        }
      });
      if (transformedData.length === 0) {
        console.log('No transformed data after filtering and matching.');
      } else {
        console.log('Transformed Data:', transformedData);
        setInvestigationDetails(transformedData);
        console.log('Investigation list for BILL_TABLE_HEADER3:', transformedData);
      }
    }
  };

  useEffect(() => {
    if (selectedRecord) {
      if (Array.isArray(selectedRecord.tests)) {
        const testItemsList = selectedRecord.tests.flatMap((test) => {
          if (Array.isArray(test.test_item_names)) {
            return test.test_item_names.map((item) => {
              const resultValue = item.Result || '';
              return {
                _id: item._id,
                test_item_name: item.test_item_name,
                test_item_names: item.test_item_names,
                Result: resultValue,
                specimen: item.specimen,
                unit_name: item.unit_name,
                test_name: test.test_name,
                test_names: test.test_names,
                general_from: item.general_from,
                general_to: item.general_to
              };
            });
          }
          console.warn('test_item_names is not an array or is undefined', test);
          return [];
        });
        testItemsList.forEach((item) => {
          setValue(`inputValues[${item._id}].Result`, item.Result);
        });
        const keyValuePair = getKeyPathValue(selectedRecord, '', [
          '__v',
          '_id',
          'createdAt',
          'ipd_no',
          'uhid',
          'report_id',
          'patientName'
        ]);
        keyValuePair.forEach(({ key, value }) => setValue(key, value));
        setInvestigationDetails(testItemsList || []);
        setValue('sign_off_by',selectedRecord?.sign_off_by)
      } else {
        console.warn('tests is not an array or is undefined', selectedRecord.tests);
      }
    } else {
      reset();
      setInvestigationDetails([]);
    }
  }, [selectedRecord, setValue, reset, setInvestigationDetails]);



  console.log(selectedRecord,"HELLO THE AGE IS HERE")

  const formSubmit = async (formValue) => {
    if (investigationDetails.length === 0) {
      toast('Please select the Patient first', { variant: 'warning' });
      return;
    }
    const uhid = patientList?.uhid;
    const ipd = patientList?.ipd_no;
    const mobile_no = selectedRecord?.mobile_no;
    const bill_no = selectedRecord?.bill_no;
    const patientName = patientList?.patient_name;
    const age = selectedRecord?.age;
    const gender = selectedRecord?.gender;
    const doctor = selectedRecord.doctor;
    const service = selectedRecord?.service;
    setLoading(true);
    const groupedTestItems = investigationDetails.reduce((acc, item) => {
      const { test_name } = item;
      // Check if inputValues for this item exists and contains a 'Result'
      // if (!inputValues[item._id] || !inputValues[item._id].Result) {
      //   return acc; // Skip this test item if no Result is entered
      // }
      if (!acc[test_name]) {
        acc[test_name] = {
          test_name: test_name,

          test_item_names: []
        };
      }
      // Build the test item payload, ensuring necessary fields
      const testItemPayload = {
        test_item_name: item.test_item_name,
        unit_name: item.unit_name,
        specimen: item.specimen?.specimen_name || 'N/A', // Ensure specimen exists
        general_from: item.refrence_range_value?.general_from || null, // Use fallback values
        general_to: item.refrence_range_value?.general_to || null, // Use fallback values
        main_group: item.main_group || null
      };
      // Add the 'Result' from inputValues
      Object.assign(testItemPayload, inputValues[item._id]);
      acc[test_name].test_item_names.push(testItemPayload);
      return acc;
    }, {});

    // Only proceed if there are tests with results to submit
    if (Object.keys(groupedTestItems).length === 0) {
      toast('No results entered for any tests.', { variant: 'warning' });
      setLoading(false);
      return;
    }
    const payload = {
      uhid: uhid,
      ipd_no: ipd,
      mobile_no: mobile_no,
      patientName: patientName,
      bill_no: bill_no,
      age: age,
      gender: gender,
      doctor: doctor,
      service: service,
      sign_off_by: sign_off_by,
      tests: Object.values(groupedTestItems)
    };
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    try {
      const response = await request(editFlag ? '/lis-result-entry-update' : '/lis-result-entry-create', {
        method: editFlag ? 'PUT' : 'POST',
        params: editFlag ? selectedRecord._id : null,
        body: {
          ...payload,
          createdBy: user.name,
          updatedBy: editFlag ? user.name : '',
          organisation
        }
      });
      if (response?.success) {
        toast(`Successfully ${editFlag ? 'updated' : 'created'} Result Entry`, { variant: 'success' });
        // setInvestigationDetails([]);
        setResponseData(response?.data);
        setCurrentAction();
        // setTestItemsList([]);
        // setDetailList([]);
        reset();
      } else {
        toast(`Failed to ${editFlag ? 'update' : 'create'} Result Entry`, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast('Error occurred while submitting the form', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  
  const fetchTestItemData = async () => {
    try {
      const response = await request('/lis-test-item-list', { method: 'GET' });
      if (response.success) {
        setTestItemList({ loading: false, data: response.data });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setTestItemList({ loading: false, data: [] });
      }
    } catch (error) {
      toast('Error in fetching data', { variant: 'error' });
      setTestItemList({ loading: false, data: [] });
    }
  };

  useEffect(() => {
    fetchTestItemData();
  }, []);

  
  const handleQueryWindow = async () => {
    setOpenResultEntryDialog(true);
    setResultEntryList({ loading: true });
    const response = await request('/lis-result-entry-list', { method: 'GET' });
    console.log("563--",response)
    if (response.success) {
      const sortedData = response.data.sort((a, b) => b.createdAt - a.createdAt);
      setResultEntryList({ loading: false, data: sortedData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setResultEntryList({ loading: false });
    }
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/lis-result-entry-cancel',{
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled Result Entry', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Cancelled Result Entry', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/lis-result-entry-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Deleted Result Entry', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Deleted Result Entry', { variant: 'error' });
    }
    setLoading(false);
  };

  const bw = watch('bw');
  useEffect(() => {
    handleResultSearch();
  }, [input]);

  const handleResultSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    try {
      const response = await request('/lis-result-entry-list', {
        method: 'GET',
        query: { patientName: lowercasedInput }
      });
      if (response.success && Array.isArray(response.data)) {
        setResultEntryList({ loading: false, data: response.data });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setResultEntryList({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setResultEntryList({ loading: false, data: [] });
    }
  };

  const handleChange = (e) => {
    setInput(e.target.value);
  };


  const sign_off_by = watch('sign_off_by')
  
  const handleUpdateDoctor = async () => {
    setLoading(true);
    try {
      const response = await axios.put(
        `${BASE_URL}/lis-result-entry/signature/${responseData?._id}`, 
        {
          sign_off_by: sign_off_by, 
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      if (response?.data?.success) {
        toast(`Successfully Signed Off`, { variant: 'success' });
      } else {
        toast(`Failed to Sign Off`, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast('Error occurred while submitting the form', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };
  
  console.log(labAuthorityDoctor,"HELLLO LAB AUTHORITY DOCTOR IS HERE")
  console.log(currentAction,"HELLO CURRENT ACTION")
  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Result Entry
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  id={`${lastPathSegment}Write`}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => {
                    setCurrentAction('edit')}}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                  onClick={() =>
                    window.open(`/print${pathname}?refId=${responseData._id || selectedRecord._id}`, '_blank')
                  }
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                  onClick={() =>
                    window.open(`/print${pathname}/print1?refId=${responseData._id || selectedRecord._id}`, '_blank')
                  }
                >
                  Print1
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                    setSelectedRecord(null);
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1.4rem' }}>Sub Group</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="sub_group"
                      menus={subgroupDropdown.map((data) => ({ ...data, name: data.sub_group }))}
                      disabled={!['new'].includes(currentAction)}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>Signed Off</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="sign_off_by"
                      disabled={responseData.length === 0 && currentAction !== 'edit'}
                      menus={labAuthorityDoctor?.data?.map((doctor) => ({
                        ...doctor,
                        name: doctor.doctor,
                        _id: doctor?._id
                      }))}
                    />
                    <Button
                      variant="contained"
                      onClick={()=>{
                        handleUpdateDoctor()
                      }}
                      disabled={responseData.length === 0 || currentAction === 'sign_off'}
                    >
                      Signed Off
                    </Button>
                  </Stack>
                </Grid>
                <Grid item xs={8} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>B/W</Typography>
                    <Checkbox sx={{ flex: 0.1 }} name="bw" fontSize={16} disabled={!['new'].includes(currentAction)} />
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                    <TextField sx={{ flex: 0.5 }} name="from_date" type="date" disabled={bw === true ? false : true} />
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                    <TextField sx={{ flex: 0.5 }} name="to_date" type="date" disabled={bw === true ? false : true} />
                  </Stack>
                </Grid>
                <Grid container item xs={12} spacing={2}>
                  <Grid item xs={4} sx={{ display: 'flex', minHeight: '45rem', flexDirection: 'column', gap: 0.3 }}>
                    <Table
                      containerSX={{
                        flex: 1,
                        border: '1px solid rgba(0,0,0,0.27)',
                        minHeight: '50rem'
                      }}
                      data={currentAction === 'new' ? patientDataObj.data : []}
                      columns={BILL_TABLE_HEADER1}
                      size="small"
                      onDeleteHandler={handleRowDelete}
                      onRowClick={handleRowClick}
                    />
                  </Grid>
                  <Grid item xs={8} sx={{ display: 'flex', minHeight: '50rem', flexDirection: 'column', gap: 0.3 }}>
                    <Table
                      containerSX={{
                        flex: 1,
                        border: '1px solid rgba(0,0,0,0.27)',
                        minHeight: '50rem'
                      }}
                      showInputField={true}
                      columns={Bill_TABLE_HEADER3}
                      size="small"
                      data={(investigationDetails && investigationDetails) || []}
                      loading={loading}
                      handleInputChange={handleInputChange}
                      inputValues={inputValues}
                      currentAction={currentAction}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
            <Dialog
              open={openResultEntryListDialog}
              onClose={() => setOpenResultEntryDialog(false)}
              PaperProps={{ sx: { width: '80%', p: 2 } }}
              maxWidth="xl"
              scroll="body"
            >
              <Stack
                padding={0}
                direction="row"
                spacing={2}
                alignItems="center"
                justifyContent="space-between"
                borderBottom="1px solid"
                borderColor="grey.300"
              >
                <Typography variant="h4" fontWeight="bold">
                  Result Entry Query Window
                </Typography>
                <IconButton onClick={() => setOpenResultEntryDialog(false)}>
                  <CloseIcon color="error" fontSize="large" />
                </IconButton>
              </Stack>
              <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
                <MuiTextField
                  sx={{
                    width: '100%',
                    '& .MuiOutlinedInput-root': {
                      padding: '0',
                      fontSize: '14px'
                    },
                    '& .MuiOutlinedInput-input': {
                      padding: '8px 14px'
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '1.2rem'
                    }
                  }}
                  label="Search Entries"
                  variant="outlined"
                  value={input}
                  onChange={handleChange}
                />
              </Stack>
              <Table
                sx={{ mt: 0.5 }}
                columns={RESULT_ENTRY_HEADER}
                data={resultEntryList.data || []}
                loading={resultEntryList.loading}
                onRowClick={(row) => {
                  delete row.patient;
                  setSelectedRecord(row);
                  setOpenResultEntryDialog(false);
                }}
              />
            </Dialog>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
